import styled from "@emotion/styled";
import {
  Background,
  Border,
  HeartIcon,
  OutlinedHeartIcon,
  Shadow,
  Typography,
} from "@ibeckinc/ui-elements";
import { useSession } from "next-auth/react";
import React, { FC, useCallback, useState } from "react";

import { useMobile } from "../../hooks/useMobile";
import { device } from "../../utils";

const { Text } = Typography;

type Props = {
  className?: string;
  defaultChecked?: boolean;
  onAppend: () => Promise<void>;
  onDeduct: () => Promise<void>;
};

export const LikeButton: FC<Props> = ({
  className,
  defaultChecked = false,
  onAppend,
  onDeduct,
}) => {
  const { isMobile } = useMobile();
  const { data: session } = useSession();

  const [checked, setChecked] = useState(defaultChecked);
  const [hover, setHover] = useState(false);

  const handleClick = useCallback(async () => {
    if (session)
      if (!checked) await onAppend();
      else await onDeduct();
    setChecked((prev) => !prev);
  }, [checked, session, onAppend, onDeduct]);

  const handleMouseEnter = useCallback(() => {
    setHover(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setHover(false);
  }, []);

  return (
    <Root
      className={className}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {checked ? (
        <HeartIcon id="accent-heart-icon" color="accent" />
      ) : (
        <OutlinedHeartIcon color={hover ? Border.Focus : Border.Base} />
      )}
      {!isMobile() && hover && (
        <Tip>
          <Text bold="bold" lineHeight="regular" size="mini">
            いいね
          </Text>
        </Tip>
      )}
    </Root>
  );
};

const Root = styled.div`
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 44px;
  width: 44px;
  position: relative;

  @media ${device.mobile} {
    background: ${Background.Base};
    border-radius: 50%;
    box-shadow: ${Shadow.Header};
  }
`;

const Tip = styled.div`
  height: 44px;
  width: 80px;
  position: absolute;
  top: 8px;
  left: 40px;
`;
